import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import './styles/globals.css';
import './i18n';
import { App } from './App';
import { initTelegram } from './lib/telegram';

initTelegram();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60 * 24 * 7, // 7 days
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Persist read-only queries to localStorage so the app stays usable offline.
// Only cache "view" data — mutations still require connectivity.
const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'chernova-query-cache',
});

const persistableQueryKeys = new Set([
  'appointments',
  'clients',
  'client',
  'appointment',
  'stats',
  'stock',
  'expenses',
  'other_incomes',
  'services',
  'extras',
  'lengths',
  'tags',
  'masters',
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 1000 * 60 * 60 * 24 * 7,
        dehydrateOptions: {
          shouldDehydrateQuery: (query) => {
            const head = query.queryKey[0];
            return typeof head === 'string' && persistableQueryKeys.has(head);
          },
        },
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistQueryClientProvider>
  </React.StrictMode>,
);
